/* eslint-disable sort-imports */
import { registerForVrender } from './vrender';
registerForVrender();

import * as TYPES from './ts-types';
import * as core from './core';
import * as data from './data';
import * as icons from './icons';
import * as register from './register';
import * as themes from './themes';
import * as DataStatistics from './dataset/DataStatistics';
import * as pluginsDefinition from './plugins';
import type {
  ColumnDefine,
  ColumnsDefine,
  LinkColumnDefine,
  ChartColumnDefine,
  ImageColumnDefine,
  SparklineColumnDefine,
  ProgressbarColumnDefine,
  TextColumnDefine,
  GroupColumnDefine,
  ListTableConstructorOptions,
  PivotTableConstructorOptions,
  PivotChartConstructorOptions,
  IHeaderTreeDefine,
  IDimension,
  IIndicator,
  ITitleDefine,
  ICornerDefine,
  TextAlignType,
  TextBaselineType
} from './ts-types';
import { ListTableAll as ListTable } from './ListTable-all';
import { ListTableSimple } from './ListTable-simple';
// import { PivotTable } from './PivotTable';
import { PivotTableAll as PivotTable } from './PivotTable-all';
import { PivotTableSimple } from './PivotTable-simple';
import { PivotChart } from './PivotChart';
import type { MousePointerCellEvent } from './ts-types/events';
import * as CustomLayout from './render/layout';

import { updateCell } from './scenegraph/group-creater/cell-helper';
import { renderChart } from './scenegraph/graphic/contributions/chart-render-helper';
import { restoreMeasureText, setCustomAlphabetCharSet, textMeasure } from './scenegraph/utils/text-measure';
import type { BaseTableAPI } from './ts-types/base-table';

// import { container, loadCanvasPicker } from '@src/vrender';
// loadCanvasPicker(container);

export { getDataCellPath } from './tools/get-data-path';
export * from './render/jsx';
export { getTargetCell } from './event/util';
export { toBoxArray } from './tools/helper';
export { Icon } from './scenegraph/graphic/icon';
export { CUSTOM_MERGE_PRE_NAME, CUSTOM_CONTAINER_NAME } from './scenegraph/component/custom';
// 为插件等场景提供必要的 vrender 能力：只导出用到的符号，避免与 render/jsx 的导出成员发生命名冲突。
export {
  matrixAllocate,
  transformPointForCanvas,
  mapToCanvasPointForCanvas,
  registerGlobalEventTransformer,
  registerWindowEventTransformer,
  vglobal,
  Group,
  graphicUtil
} from './vrender';

// export * as VRender from './vrender';
// import * as VRender from './vrender';

export const version = "1.26.1";
/**
 * @namespace VTable
 */
export {
  /**
   * Types
   * @namespace VTable.TYPES
   */
  TYPES,
  core,
  ListTable,
  ListTableSimple,
  BaseTableAPI,
  ListTableConstructorOptions,
  PivotTable,
  PivotTableSimple,
  PivotTableConstructorOptions,
  PivotChartConstructorOptions,
  PivotChart,
  IHeaderTreeDefine,
  IDimension,
  IIndicator,
  ITitleDefine,
  ICornerDefine,
  ColumnsDefine,
  ColumnDefine,
  LinkColumnDefine,
  ChartColumnDefine,
  ImageColumnDefine,
  SparklineColumnDefine,
  ProgressbarColumnDefine,
  TextColumnDefine,
  GroupColumnDefine,
  TextAlignType,
  TextBaselineType,
  textMeasure,
  themes,
  data,
  MousePointerCellEvent,
  getIcons,
  clearGlobal,
  //plugin registers
  register,
  /**
   * 暂不推荐使用
   */
  DataStatistics,
  CustomLayout,
  updateCell,
  renderChart,
  setCustomAlphabetCharSet,
  restoreMeasureText,
  pluginsDefinition
};

/** @private */
function getIcons(): {
  [key: string]: TYPES.ColumnIconOption;
} {
  return icons.get();
}
/** 清理内部的全局变量 如注册的icon theme等 以及共享的header column类实例 */
function clearGlobal() {
  register.clearAll();
  // headers.type.clearGlobal();
  // columns.type.clearGlobal();
}
TYPES.AggregationType;

export * from './components';
export * from './scenegraph/group-creater/cell-type';

export { TABLE_EVENT_TYPE } from './core/TABLE_EVENT_TYPE';
export { PIVOT_CHART_EVENT_TYPE, PIVOT_TABLE_EVENT_TYPE } from './ts-types/pivot-table/PIVOT_TABLE_EVENT_TYPE';

export { EventTarget } from './event/EventTarget';
